import React from 'react';
import manu_1 from '../Images/P-1.png'
import manu_2 from '../Images/P-2.png'
import manu_3 from '../Images/P-3.png'
import manu_4 from '../Images/P-4.png'
import manu_5 from '../Images/P-5.png'


const AllProjects = () => {
    return (
        <div>
            <h1 className='text-center text-3xl font-bold mb-10 mt-14 uppercase text-orange-500'>All Projects</h1>

            <div className='grid grid-cols-1 lg:grid-cols-2 gap-8 justify-items-center'>
                {/* card-1 */}
                <div class="card w-96 bg-base-100 shadow-xl">
                    <figure><img src={manu_1} alt="Shoes" /></figure>
                    <div class="card-body">
                        <h2 class="card-title">
                            Computer Parts Manufacturer
                            <div class="badge badge-secondary">NEW</div>
                        </h2>
                        <p>Full stack dynamic company website</p>
                        <p>Technology used: HTML, Tailwind CSS, Daisy UI, React Js, JavaScript, Google Firebase, React
                            Router, React toastify, React hook form, NodeJs, Express Js, Mongo DB, JSON web token</p>
                        <p>Live link - https://computer-parts-manufactu-88a04.web.app/      </p>
                        <p>Code link - https://github.com/tauhidurrana/manufacturer-parts-website-client-side     </p>
                        <div class="card-actions justify-end">
                            <div class="badge badge-outline">Company</div>
                            <div class="badge badge-outline">Products</div>
                        </div>
                    </div>
                </div>
                {/* card-2 */}
                <div class="card w-96 bg-base-100 shadow-xl">
                    <figure><img src={manu_2} alt="Shoes" /></figure>
                    <div class="card-body">
                        <h2 class="card-title">
                            Travel Guider
                            <div class="badge badge-secondary">NEW</div>
                        </h2>
                        <p>Full stack dynamic company website</p>
                        <p>Technology used: HTML, Tailwind CSS, Daisy UI, React Js, JavaScript, Google Firebase, React
                            Router, React toastify, React hook form, NodeJs, Express Js, Mongo DB, JSON web token</p>
                        <p>Live link -https://travel-guider-9a77b.web.app/      </p>
                        <p>Code link -https://github.com/tauhidurrana/travel-guider     </p>
                        <div class="card-actions justify-end">
                            <div class="badge badge-outline">Travel</div>
                            
                        </div>
                    </div>
                </div>
                {/* card-3 */}
                <div class="card w-96 bg-base-100 shadow-xl">
                    <figure><img src={manu_3} alt="Shoes" /></figure>
                    <div class="card-body">
                        <h2 class="card-title">
                            Electronics Warehouse Management
                        </h2>
                        <p>Full stack dynamic company website</p>
                        <p>Technology used: HTML, Tailwind CSS, Daisy UI, React Js, JavaScript, Google Firebase, React
                            Router, React toastify, React hook form, NodeJs, Express Js, Mongo DB, JSON web token</p>
                        <p>Live link - https://warehouse-manage-2f330.web.app/     </p>
                        <p>Code link - https://github.com/tauhidurrana/electronic-warehouse-client-side     </p>
                        <div class="card-actions justify-end">
                            <div class="badge badge-outline">Inventory</div>
                        </div>
                    </div>
                </div>
                {/* card-4 */}
                <div class="card w-96 bg-base-100 shadow-xl">
                    <figure><img src={manu_4} alt="Shoes" /></figure>
                    <div class="card-body">
                        <h2 class="card-title">
                            Sneaker Park

                        </h2>
                        <p>Full stack dynamic company website</p>
                        <p>Technology used: HTML, Tailwind CSS, Daisy UI, React Js, JavaScript, Google Firebase, React
                            Router, React toastify, React hook form, NodeJs, Express Js, Mongo DB, JSON web token</p>
                        <p>Live link - https://sneaker-park-bd-tauhidurrana.netlify.app/      </p>
                        <p>Code link -https://github.com/tauhidurrana/sneaker-park   </p>
                        <div class="card-actions justify-end">
                            <div class="badge badge-outline">Fashion</div>
                            <div class="badge badge-outline">Products</div>
                        </div>
                    </div>
                </div>
                {/* card-5 */}
                <div class="card w-96 bg-base-100 shadow-xl">
                    <figure><img src={manu_5} alt="Shoes" /></figure>
                    <div class="card-body">
                        <h2 class="card-title">
                            Product Analyser

                        </h2>
                        <p>Full stack dynamic company website</p>
                        <p>Technology used: HTML, Tailwind CSS, Daisy UI, React Js, JavaScript, Google Firebase, React
                            Router, React toastify, React hook form, NodeJs, Express Js, Mongo DB, JSON web token</p>
                        <p>Live link - https://product-analyser-tauhidurrana.netlify.app/     </p>
                        <p>Code link - https://github.com/tauhidurrana/product-analysis-website     </p>
                        <div class="card-actions justify-end">
                            <div class="badge badge-outline">Gear</div>
                            <div class="badge badge-outline">Products</div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default AllProjects;